import { render, staticRenderFns } from "./IrrigationForecast.vue?vue&type=template&id=18189aaa&scoped=true"
import script from "./IrrigationForecast.vue?vue&type=script&lang=js"
export * from "./IrrigationForecast.vue?vue&type=script&lang=js"
import style0 from "./IrrigationForecast.vue?vue&type=style&index=0&id=18189aaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18189aaa",
  null
  
)

export default component.exports